export const wyrm_list_2 = [
  {
    type: 0,
    id: 400001,
    abilities: [ 
      { exclusive: '', effect: 'crt_rt', value: 4, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400002,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 15, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400003,
    abilities: [ 
      { exclusive: '', effect: 'shs_prp', value: 10, maxValue: 10}
    ]
  }, {
    type: 0,
    id: 400004,
    abilities: [ 
      { exclusive: '', effect: 'skl_dmg', value: 15, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400005,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 5, maxValue: 20}
    ]
  }
].reverse()